import React from "react";
import { TableCell } from "@material-ui/core";
import clsx from "clsx";
import ElipsisText from "./ElipsisText";
import SwipeIcon from "../../../../assets/images/swipe-icon.svg";
import WaveXchangeIcon from "../../../../assets/images/wavexchange-small-icon.svg";

export interface TitleSubtitleProps {
  title: string | number;
  titleNode?: React.ReactNode;
  subTitle?: string | number;
  align: "left" | "center" | "right";
  width: string;
  maxWidth: string;
  boldTitle?: boolean;
  boldSubtitle?: boolean;
  isSwipeIcon?: boolean;
  isOnNetNE?: boolean;
  blackBorder?: boolean;
  bdGroupInnerRow?: number;
  outlineColor?: string;
}

const TitleSubtitle: React.FC<TitleSubtitleProps> = ({
  title,
  subTitle,
  outlineColor,
  align,
  width,
  blackBorder,
  titleNode,
  maxWidth,
  boldTitle,
  boldSubtitle,
  isSwipeIcon,
  isOnNetNE,
  bdGroupInnerRow: groupRowNumber,
}) => {
  return (
    <TableCell align={align} width={width} className={clsx(blackBorder && "black-line", groupRowNumber && `bd-group-inner-row-${groupRowNumber}`)}>
      <div className={`outline-${outlineColor}`}>
        <div className={clsx(boldTitle && "bold-font")} data-testid="title">
          {isOnNetNE ? (
            <div style={{ display: "flex", justifyContent: align }}>
              <img style={{ paddingRight: "3px" }} src={WaveXchangeIcon} alt="on net fabricon" />
              <ElipsisText node={titleNode} text={title ? title.toString() : ""} width={maxWidth} />
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: align }}>
              <ElipsisText node={titleNode} text={title ? title.toString() : ""} width={maxWidth} />
            </div>
          )}
        </div>
        {subTitle && (
          <div className={clsx("subtitle", boldSubtitle && "bold-font")} data-testid="sub-title">
            <ElipsisText text={subTitle.toString()} width={maxWidth} />
            {isSwipeIcon && (
              <span className={clsx(SwipeIcon && "swipe-icon-table")}>
                <img src={SwipeIcon} alt="Swipe" data-testid="swipe-icon" />
              </span>
            )}
          </div>
        )}
      </div>
    </TableCell>
  );
};

export default TitleSubtitle;
